// src/utils/firebase.js
// ─────────────────────────────────────────────
// SETUP: Replace these values with your own from
// Firebase Console → Project Settings → Your Apps
// ─────────────────────────────────────────────
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCua5_dFVk6PszVUFmWwNwU-IUbKFWXBVI",
  authDomain: "resumescoreai-1df09.firebaseapp.com",
  projectId: "resumescoreai-1df09",
  storageBucket: "resumescoreai-1df09.firebasestorage.app",
  messagingSenderId: "253717915290",
  appId: "1:253717915290:web:21a9021aae38081a59e123",
  measurementId: "G-ZH99ZNP0WX"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
